import React, { memo } from "react"
import PropTypes from "prop-types"
import AddRoleModal from "./AddRoleModal"
import EditRoleModal from "./EditRoleModal"
import DeleteRoleModal from "./DeleteRoleModal"
import DeleteRoleWithReassignModal from "./DeleteRoleWithReassignModal"

const RoleModals = ({
  isAddRoleModalOpen,
  isEditRoleModalOpen,
  isDeleteReassignModalOpen,
  isDeleteRoleModalOpen,
  editingRole,
  deletingRole,
  assignedStaffForRole,
  availableRoles,
  onCloseAddModal,
  onCloseEditModal,
  onCloseReassignModal,
  onCloseDeleteModal,
  onSaveNewRole,
  onSaveEditRole,
  onReassignConfirm,
  onReassignSkip,
  onConfirmDelete
}) => {
  return (
    <>
      <AddRoleModal open={isAddRoleModalOpen} onCancel={onCloseAddModal} onSave={onSaveNewRole} />

      <EditRoleModal open={isEditRoleModalOpen} onCancel={onCloseEditModal} onSave={onSaveEditRole} roleData={editingRole} />

      <DeleteRoleWithReassignModal
        open={isDeleteReassignModalOpen}
        onCancel={onCloseReassignModal}
        onConfirm={onReassignConfirm}
        onSkip={onReassignSkip}
        roleName={deletingRole?.name}
        assignedStaff={assignedStaffForRole}
        availableRoles={availableRoles}
      />

      <DeleteRoleModal open={isDeleteRoleModalOpen} onCancel={onCloseDeleteModal} onConfirm={onConfirmDelete} roleName={deletingRole?.name} />
    </>
  )
}

RoleModals.propTypes = {
  isAddRoleModalOpen: PropTypes.bool.isRequired,
  isEditRoleModalOpen: PropTypes.bool.isRequired,
  isDeleteReassignModalOpen: PropTypes.bool.isRequired,
  isDeleteRoleModalOpen: PropTypes.bool.isRequired,
  editingRole: PropTypes.object,
  deletingRole: PropTypes.object,
  assignedStaffForRole: PropTypes.array.isRequired,
  availableRoles: PropTypes.array.isRequired,
  onCloseAddModal: PropTypes.func.isRequired,
  onCloseEditModal: PropTypes.func.isRequired,
  onCloseReassignModal: PropTypes.func.isRequired,
  onCloseDeleteModal: PropTypes.func.isRequired,
  onSaveNewRole: PropTypes.func.isRequired,
  onSaveEditRole: PropTypes.func.isRequired,
  onReassignConfirm: PropTypes.func.isRequired,
  onReassignSkip: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired
}

export default memo(RoleModals)
